export default __webpack_public_path__ + "static/media/keyboard.bae41dd0.png";